module.exports = __webpack_public_path__ + "static/media/pool-skimmer-image-3.dd374bcb.jpg";